import { useSelector } from '@store';
import { ReactNode, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface Props {
  children?: ReactNode;
}

const GTMWrapper = ({ children }: Props) => {
  const { pathname, search } = useLocation();

  const userId = useSelector((state) => state.client.id);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({ event: 'page_view' });

    if (!userId) return;

    window.dataLayer.push({
      userId: userId
    });
  }, [userId, pathname, search]);

  return <>{children}</>;
};

export default GTMWrapper;
